<template>
    <div class="hidden-xs col-xs-12 col-sm-5 text-center">
        <div class="send-games">
            <!-- onclick should trigger input -->
            <h3
                v-show="gameSearchForm.showQuestion"
                class="text-green m-a-0 pointer"
                @click="gameSearchForm.showSelect = true,
                        gameSearchForm.showThanks = false,
                        gameSearchForm.showQuestion = false"
            >
                Can't find a game you were looking for?
            </h3>
            <h3
                v-show="gameSearchForm.showThanks"
                class="sub-mss text-white pointer thanks-voting"
                title="Click to to suggest other game"
                @click="gameSearchForm.showThanks = false,
                        gameSearchForm.showSelect = true"
            >
                Thanks for voting this game up!
            </h3>
            <!-- input-group for send games -->
            <template v-if="gameSearchForm.showSelect">
                <multiselect v-model="suggestedGame"
                    id="suggest-game"
                    label="name"
                    track-by="id"
                    :value="suggestedGameQuery"
                    placeholder="INSERT GAME NAME"
                    :deselectLabel="''"
                    :selectLabel="''"
                    :selectedLabel="''"
                    :options="suggestedGames"
                    :loading="isLoadingSuggestedGames"
                    :searchable="true"
                    :clearOnSelect="false"
                    :internal-search="false"
                    :preserveSearch="true"
                    :hide-selected="false"
                    :showNoResults="true"
                    :options-limit="10"
                    :limit="10"
                    :max-height="600"
                    open-direction="top"
                    @search-change="getSugggestedGames">

                    <template slot="option" slot-scope="props">
                        <div class="option__desc">
                            <span class="option__title">
                                {{ props.option.name }}
                            </span>
                        </div>
                    </template>
                    <span slot="noOptions" class="no-options-select">SEARCH FOR A GAME</span>
                    <span slot="noResult">OOPS! NO GAMES FOUND</span>
                </multiselect>

                <button
                    :disabled="isSendingGame || (suggestedGame && !suggestedGame.name)"
                    class="btn btn-green btn-outline small-send-btn"
                    :class="{'disable-element': isSendingGame}"
                    @click="sendGameSuggestion()"
                >
                    SEND
                </button>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "SuggestedGames",
    data() {
        return {
            gameSearchForm: {
                showQuestion: true,
                showSelect: false,
                showThanks: false
            },
            isLoadingSuggestedGames: false,
            suggestedGames: [],
            suggestedGame: null,
            suggestedGameQuery: "",
            isSendingGame: false
        }
    },
    watch: {
        "gameSearchForm.showSelect"(isTrue) {
            if (isTrue) {
                this.$nextTick(() => {
                    $("#suggest-game").focus();
                })
            }
        }
    },
    methods: {
        getSugggestedGames: _.debounce(function(suggestedGameQuery) {
            if (!suggestedGameQuery) {
                return;
            }

            this.isLoadingSuggestedGames =  true;
            this.suggestedGameQuery = suggestedGameQuery;

            const WINDOWS_PC_GAMES = 6;

            const filters = {
                search: suggestedGameQuery,
                fields: "name",
                "filter[platforms][any]": WINDOWS_PC_GAMES,
                limit: 10
            }

            axios({
                url: `/find-games-suggestions/?${$.param(filters)}`,
                method: "GET",
            }).then(({ data: suggestedGames }) => {
                this.suggestedGames = suggestedGames;
            }).finally(() => this.isLoadingSuggestedGames = false);

        }, 300),
        sendGameSuggestion() {
            if (this.suggestedGame && this.suggestedGame.name) {
                const data = new FormData();
                data.append('name', _.unescape(this.suggestedGame.name));
                this.isSendingGame = true;
                axios.post('games-suggestions', data).then(() => {
                    this.suggestedGame = {}
                    this.suggestedGames = [];
                    this.suggestedGameQuery = "";
                    this.gameSearchForm.showThanks = true;
                    this.gameSearchForm.showSelect = false;
                }).finally(() => this.isSendingGame = false)
            }
        }
    }
}
</script>

<style lang="scss">
@import '~@s/_asset-mixers.scss';

#suggest-game {
    width: 81% !important;
}

.thanks-voting {
    margin: 0;
}

.send-games {
    display: flex;
    justify-content: center;
    align-items: center;


    .multiselect {
        margin-right: 10px;
    }

    .multiselect__option--selected.multiselect__option--highlight {
        background: $purple !important;
    }
    .multiselect__option--highlight {
        background: $purple !important;
    }

    .small-send-btn {
        padding: 9px 30px;
    }
}

</style>
